(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = document.documentElement;

  // Header border once the page scrolls
  const onScroll = () => root.classList.toggle('cb-scrolled', window.scrollY > 8);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  // Reveal on scroll
  const initReveal = (scope) => {
    const els = scope.querySelectorAll('[data-cb-reveal]:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    els.forEach((el) => io.observe(el));
  };

  // Product rail arrows
  const initRails = (scope) => {
    scope.querySelectorAll('[data-cb-rail]').forEach((rail) => {
      if (rail.dataset.cbReady) return;
      rail.dataset.cbReady = '1';
      const track = rail.querySelector('.cb-rail__track');
      const prev = rail.querySelector('.cb-rail__btn--prev');
      const next = rail.querySelector('.cb-rail__btn--next');
      if (!track || !prev || !next) return;
      const step = () => {
        const item = track.querySelector('.cb-rail__item');
        return item ? item.getBoundingClientRect().width * 2 + 24 : track.clientWidth * 0.8;
      };
      const update = () => {
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      };
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  };

  // Gentle parallax on feature band images
  const initParallax = (scope) => {
    if (reduce) return;
    const imgs = [...scope.querySelectorAll('.cb-parallax')];
    if (!imgs.length) return;
    let ticking = false;
    const run = () => {
      const vh = window.innerHeight;
      imgs.forEach((img) => {
        const r = img.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const p = (r.top + r.height / 2 - vh / 2) / vh; // -1..1
        img.style.transform = `translate3d(0, ${(p * -6).toFixed(2)}%, 0)`;
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(run);
      }
    }, { passive: true });
    run();
  };

  const init = (scope = document) => {
    initReveal(scope);
    initRails(scope);
    initParallax(scope);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
